import { envConfig } from "../../../config";

export const translations = {
  p1: {
    es: `¿Sabías que puedes conectar la aplicación de ${envConfig.companyName} con RD Station?`,
    en: `Did you know that you can connect the ${envConfig.companyName} application with RDStation?`
  },
  p2: {
    es: "Conectarlo es muy sencillo:",
    en: "Connecting it is very simple:"
  },
  p4: {
    es: `Coloca los datos de tu cuenta en RD Station y acepta los permisos para trabajar junto con ${envConfig.companyName}.`,
    en: `Put your RD Station account and accept the permissions to work together with ${envConfig.companyName}.`
  },
  p5: {
    neutral: {
      es: "Por último, elige en ",
      en: "Finally, choose in"
    },
    strong: {
      es: `cuál de tus tiendas de ${envConfig.companyName} quieres recibir los datos de tus clientes de RD Station.`,
      en: `which of your ${envConfig.companyName} stores you want to receive data from your RD Station customers.`
    }
  },
  p6: {
    es: "¡Listo! ¡Ya estás conectado!",
    en: "Done! You're already connected!"
  },
  p7: {
    text: {
      es: "Para mayor información, haz",
      en: "For more information, do",
    },
    link: {
      es: "click aquí",
      en: "click here"
    }
  }
}